module.exports = __webpack_public_path__ + "files/6985640fbb09579efcef83815416a0be.svg";